(function ($) {
  $(document).ready(function () {
    var toTop = $('.to-top');
    var footerBottom = $('#footer-bottom');
    var vertPosition = footerBottom.offset().top;
    var browserHeight = $(window).innerHeight();
    var dealButtons = null;
    var dealButtonsHeight = 0;
    var margin = $('body').css('margin-top').split('px')[0];

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      browserHeight = window.screen.height;
    }

    $(window).on('scroll', function () {
      vertPosition = footerBottom.offset().top;
      browserHeight = $(window).innerHeight();
      margin = ($('body').css('margin-top').split('px')[0]) * 1;

      if (dealButtons === null) {
        dealButtons = $('.deal-btn-wrapper.clonedElement');
        dealButtonsHeight = dealButtons.innerHeight();
      }

      if (toTop.offset().top + (toTop.innerHeight() / 2) > vertPosition) {
        toTop.css({ position: 'absolute', top: vertPosition - margin - (toTop.innerHeight() / 2) + 'px', bottom: 'unset' });
      }

      if (toTop.hasClass('deals-on')) {
        dealButtonsHeight = dealButtons.innerHeight();
        toTop.css({ bottom: dealButtonsHeight + 'px', top: 'unset' });
      }

      if ($(window).scrollTop() + (browserHeight - toTop.innerHeight() / 2 - 20) < vertPosition) {
        if (!toTop.hasClass('deals-on')) {
          toTop.removeAttr('style');
        }

        if ($(this).scrollTop() > 94) {
          toTop.addClass('fixed');
        } else {
          toTop.removeClass('fixed');
        }
      }
    });

    toTop.on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      return false;
    });
  });
}(jQuery));
